"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequest = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var swr_1 = (0, tslib_1.__importDefault)(require("swr"));
var requester = axios_1.default.create({
    baseURL: process.env.REACT_APP_REST_BASE_URL,
});
function useRequest(request, _a) {
    if (_a === void 0) { _a = {}; }
    var fallbackData = _a.fallbackData, config = (0, tslib_1.__rest)(_a, ["fallbackData"]);
    var _b = (0, swr_1.default)(request && JSON.stringify(request), 
    // Typescript thinks request can be null, but the fetcher function is only called by useSWR if it isn't null.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    function () { return requester.request(request); }, (0, tslib_1.__assign)((0, tslib_1.__assign)({}, config), { fallbackData: fallbackData && {
            status: 200,
            statusText: 'InitialData',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            config: request,
            headers: {},
            data: fallbackData,
        } })), response = _b.data, error = _b.error, isValidating = _b.isValidating, mutate = _b.mutate;
    return {
        data: response && response.data,
        response: response,
        error: error,
        isValidating: isValidating,
        mutate: mutate,
    };
}
exports.useRequest = useRequest;
